import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { BehaviorSubject, takeUntil } from 'rxjs';
import { RepoContact, RepoPosition } from '../../models/repo-business/repo-business.model';
import { HttpErrorHandlerService } from '../../services/http-error-handler.service';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { RepoBusinessFacade } from '../../shared-new/store/repo-business/repo-business.facade';
import Swal from 'sweetalert2';
import { ToastService } from '../../shared-new/services/toast.service';
import { MatSort } from '@angular/material/sort';
import { RepoContactListDataSource } from '../repocontact-list/repocontact-list.datasource';
import { RepoPositionListDataSource } from './position-list.datasource';
@Component({
  selector: 'app-position-list',
  templateUrl: './position-list.component.html',
  styleUrls: ['./position-list.component.scss']
})
export class PositionListComponent extends BaseUnsubscribeComponent implements OnInit {
  public dataSource: RepoPositionListDataSource;
  
  success$ = this.repoBusinessFacade.success$;
  @ViewChild(MatSort) positionSort: MatSort;
  private _searchTerm: string = '';
  @Input() tablePosition: ElementRef;
  @Input() public set searchTerm(value: string) {
    this._searchTerm = value;
    if (this.dataSource) {
      this.dataSource.searchTable(value);
    }
  }
  public get searchTerm(): string {
    return this._searchTerm;
  }
  @Input() public set positions(positions: RepoPosition[]) {
    if (positions) {
      setTimeout(() => {
        const scrollLevel = this.dataSource?.infiniteScrollLevel || 20;
        this.dataSource = new RepoPositionListDataSource(positions, this.positionSort, false, scrollLevel);
        if (this.searchTerm) {
          this.dataSource.searchTable(this.searchTerm);
        }
      }, 100);
    }
  }
  @Output() editRepoPosition = new EventEmitter();
  public displayedColumns$ = new BehaviorSubject([
    'positionName',
    'actions',
  ]);
  constructor(private readonly repoBusinessFacade: RepoBusinessFacade, private httpErrorHandlerService: HttpErrorHandlerService, private readonly toastService: ToastService) {
      super();
  }

  ngOnInit(): void {
    this.attachEvents();
  }
  private attachEvents(): void {
    this.success$.pipe(takeUntil(this.unsubscribe$)).subscribe((response) => {
      if (response?.deletePosition) {
        this.toastService.success('Position Deleted', 'Success!');
        this.repoBusinessFacade.loadPositions();
      }
    });
  }

  public onTableScroll(): void {
    this.dataSource.onScroll();
  }

  public trackByPosition(index: number, contact: RepoPosition): number {
    return contact.positionId;
  }

  public EditPosition(repoPosition: RepoPosition): void {
    this.editRepoPosition.emit(repoPosition);
  }

  public DeletePosition(position: RepoPosition): void {
    let confirmText = '';
    if (position.isLinkedToContact) {
      confirmText = '<i class="fa fa-exclamation-circle text-danger"></i>&nbsp;This position is used in other contacts. They will be updated to have no position.<br /><br />';
    }

    Swal.fire({
      title: 'Remove Position',
      html: `${confirmText}Are you sure you want to remove the position? This is an irreversible action.`,
      showCancelButton: true,
      cancelButtonText: 'Cancel',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Delete',
      confirmButtonColor: '#1b6da6',
    }).then((result) => {
      if (result.value) {
        this.repoBusinessFacade.deletePosition(position.positionId);
      }
    });

  }
}
